import Vue from 'vue'
import Toasted from 'vue-toasted'
import router from './router'

Vue.use(Toasted, {
    iconPack: 'mdi',
    duration: 5000,
    keepOnHover: true,
    router
})

Vue.toasted.register (
    'defaultSuccess',
    payload => !payload.msg ? 'Operação realidada com sucesso!' : payload.msg,
    { type: 'success', icon: 'check' }
)

Vue.toasted.register (
    'defaultError',
    payload => !payload.msg ? 'Oops.. Erro inesperado.' : payload.msg,
    { type : 'error', icon : 'warning' }
)

Vue.toasted.register (
    'defaultInfo',
    payload => !payload.msg ? 'Info:' : payload.msg,
    { 
        type : 'info', 
        icon : 'information',  
        duration: 10000,
        action : {
            text : 'Abrir',
            push : { 
                name : 'logsPagesId',
                dontClose : true
            }
        }
    }
)

Vue.toasted.register (
    'defaultLoading',
    payload => !payload.msg ? 'Carregando...' : payload.msg,
    { type : 'info', icon : 'hourglass_empty' }
)